// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__3kB0W","Desktop":"NavBar_Desktop__CpTjW","Burger":"NavBar_Burger__1xvhM","NavBarMobile":"NavBar_NavBarMobile__2yC75"};